var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIconBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0662B9;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.4,1.7c-0.1-0.1-0.4-0.1-0.5,0L4,9.5L1.1,7.1C0.9,7,0.7,7,0.6,7.1c-0.1,0.1-0.2,0.4,0,0.5c0,0,0,0,0.1,0.1 l3.2,2.5c0.1,0.1,0.4,0.1,0.5,0l7.1-8C11.6,2.1,11.6,1.9,11.4,1.7C11.4,1.7,11.4,1.7,11.4,1.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIconBlue);
export default __webpack_public_path__ + "static/media/success_icon_blue.6bbe94f7863b3e8e77d9c151b0a48406.svg";
export { ForwardRef as ReactComponent };